import MicroModal from "micromodal";

(function () {
	MicroModal.init({
		disableFocus: true,
		onClose: (modal) => {
			document.querySelector('[data-micromodal-trigger="' + modal.id + '"]').focus();
		},
	});

	if(new URL(window.location).searchParams.get('trigger') === 'login'){
		if(document.getElementById('login-modal')){
			MicroModal.show('login-modal')
		}
	}
})();
